import React from "react";
import { useApp } from "@/context/AppContext";
import SEO from "@/components/SEO";

const blocks = {
  fr: {
    title: "Mentions légales",
    desc: "Mentions légales et identité de l'éditeur du site Lux·Pension.",
    sections: [
      ["Éditeur du site", "Lux·Pension est un outil informatif édité par un particulier. Pour toute question : contact@pensioncheck.online."],
      ["Hébergement", "Site hébergé sur l'infrastructure Emergent (https://emergent.sh). Stockage des données en MongoDB managée."],
      ["Propriété intellectuelle", "Le code, le design et le contenu éditorial du site sont la propriété de l'éditeur. Reproduction interdite sans autorisation préalable."],
      ["Avertissement", "Lux·Pension fournit des estimations basées sur la formule officielle CNAP simplifiée et les barèmes 2025. Ces résultats ne constituent pas une décision officielle de la CNAP, ni un conseil juridique ou fiscal. Pour toute décision personnelle, consultez la CNAP ou un conseiller agréé."],
      ["Loi applicable", "Le présent site est régi par le droit luxembourgeois. Tout litige sera porté devant les tribunaux de Luxembourg-Ville."],
    ],
  },
  en: {
    title: "Legal notice",
    desc: "Legal notice and publisher identity for the Lux·Pension website.",
    sections: [
      ["Publisher", "Lux·Pension is an informational tool published by an individual. Contact: contact@pensioncheck.online."],
      ["Hosting", "The site is hosted on the Emergent infrastructure (https://emergent.sh). Data stored in managed MongoDB."],
      ["Intellectual property", "The code, design and editorial content of the site are owned by the publisher. Reproduction prohibited without prior authorization."],
      ["Disclaimer", "Lux·Pension provides estimates based on the simplified official CNAP formula and 2025 tax brackets. These results are not an official CNAP decision, nor legal/tax advice. For any personal decision, consult the CNAP or a qualified advisor."],
      ["Governing law", "This website is governed by Luxembourg law. Any dispute will be brought before the courts of Luxembourg City."],
    ],
  },
  de: {
    title: "Impressum",
    desc: "Impressum und Verlegerangaben für die Lux·Pension-Website.",
    sections: [
      ["Herausgeber", "Lux·Pension ist ein Informationstool, das von einer Privatperson herausgegeben wird. Kontakt: contact@pensioncheck.online."],
      ["Hosting", "Die Website wird auf der Emergent-Infrastruktur (https://emergent.sh) gehostet. Datenspeicherung in verwalteter MongoDB."],
      ["Geistiges Eigentum", "Code, Design und redaktionelle Inhalte sind Eigentum des Herausgebers. Vervielfältigung ohne vorherige Genehmigung verboten."],
      ["Haftungsausschluss", "Lux·Pension liefert Schätzungen auf Grundlage der vereinfachten offiziellen CNAP-Formel und der Steuersätze 2025. Diese Ergebnisse sind keine offizielle CNAP-Entscheidung und keine Rechts- oder Steuerberatung."],
      ["Anwendbares Recht", "Diese Website unterliegt dem luxemburgischen Recht. Etwaige Streitigkeiten werden vor den Gerichten der Stadt Luxemburg ausgetragen."],
    ],
  },
};

const LegalPage = () => {
  const { lang } = useApp();
  const c = blocks[lang] || blocks.fr;
  return (
    <section className="max-w-3xl mx-auto px-6 md:px-8 py-16" data-testid="legal-page">
      <SEO title={c.title} description={c.desc} path="/legal" />
      <div className="border-b border-slate-200 pb-6 mb-10">
        <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-slate-500">/ legal · impressum</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-slate-900 mt-2">{c.title}</h1>
      </div>
      <div className="space-y-10">
        {c.sections.map(([h, body]) => (
          <div key={h}>
            <h2 className="font-serif text-2xl text-slate-900 mb-3">{h}</h2>
            <p className="text-base text-slate-700 leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LegalPage;
